export class MediaBackgroundCanvas {
    media;
    canvas;
    step;
    ctx;

    constructor(mediaElement, canvasElement) {
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        if (!mediaQuery.matches) {
            this.media = mediaElement;
            this.canvas = canvasElement;
            this.init();
        }
    }
    draw = () => {
        this.ctx.drawImage(this.media, 0, 0, this.canvas.width, this.canvas.height);
    };
    drawLoop = () => {
        this.draw();
        this.step = window.requestAnimationFrame(this.drawLoop);
    };
    drawPause = () => {
        window.cancelAnimationFrame(this.step);
        this.step = undefined;
    };
    init = () => {
        this.ctx = this.canvas.getContext("2d");
        if (this.media instanceof HTMLVideoElement) {
            this.media.addEventListener("loadeddata", this.draw, false);
            this.media.addEventListener("seeked", this.draw, false);
            this.media.addEventListener("play", this.drawLoop, false);
            this.media.addEventListener("pause", this.drawPause, false);
            this.media.addEventListener("ended", this.drawPause, false);
        } else if (this.media instanceof HTMLImageElement) {
            this.draw();
        }
    };
    cleanup = () => {
        if (this.media instanceof HTMLVideoElement) {
            this.media.removeEventListener("loadeddata", this.draw);
            this.media.removeEventListener("seeked", this.draw);
            this.media.removeEventListener("play", this.drawLoop);
            this.media.removeEventListener("pause", this.drawPause);
            this.media.removeEventListener("ended", this.drawPause);
        }
    };
}